import { render } from "./ProductAttributeGrid.vue?vue&type=template&id=164844b8"
import script from "./ProductAttributeGrid.vue?vue&type=script&lang=ts"
export * from "./ProductAttributeGrid.vue?vue&type=script&lang=ts"
script.render = render

export default script